import { render } from "./NewWord.vue?vue&type=template&id=6ad91d06"
import script from "./NewWord.vue?vue&type=script&lang=js"
export * from "./NewWord.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__